// サンプルテキストの追加
import commonClass from "./commonClass";

export default class insertTxtClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._$trg = $('.js-ex_txt-trg'); //サンプルボタン
    this._$tgt = $('.js-ex_txt-tgt'); //サンプルが入力されるテキストエリア
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;
    cls._$trg.on('click', function(){
      var txt = cls._$tgt.val();
      if(txt !== "") txt += '\n';
      txt = txt + cls._$tgt.next().text();
      cls._$tgt.val(txt);
    });
  }

}